import "./organization-logo-edit-image.scss";
import React, { useEffect } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useFormDataValidation, useImageCropper } from "../../hooks/formHooks";
import {
  selectCurrentOrganization,
  setSelectedOrganization,
} from "../../reducers/organizationSlice";
import { useNavigate } from "react-router-dom";
import { getOrgLogoEditForm } from "../../forms/OrganizationForm";

const OrganizationLogoEditImage = (props) => {
  const navigate = useNavigate();

  const currentOrganization = useSelector(selectCurrentOrganization);
  const property = "logo";

  const [context, isValid] = useFormDataValidation({
    initialValid: true,
    data: currentOrganization,
    setData: setSelectedOrganization,
  });

  const [
    croppedImg,
    showCroppedImage,
    saveCroppedLogo,
    applyCrop,
    undoCrop,
    croppedImgBlob,
  ] = useImageCropper(context, property);

  useEffect(() => {
    const editor = document.getElementById("image-editor");
    editor.focus();
  }, []);

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveLogo,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const saveLogo = () => {
    saveCroppedLogo();
    leftNavigation();
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: `Edit Logo Image`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  context.getActions = () => {
    if (!showCroppedImage) {
      return [
        { buttonTitle: "Preview", actionClick: applyCrop, type: "transparent" },
      ];
    } else {
      return [
        {
          buttonTitle: "revert",
          actionIcon: faUndoAlt,
          actionClick: undoCrop,
          type: "transparent red",
        },
      ];
    }
  };

  context.getLogo = () => {
    return currentOrganization?.[property];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Edit Image"
        formActions={context.getActions()}
        formSections={getOrgLogoEditForm(context, showCroppedImage, croppedImg)}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const keyPressed = () => {
    saveLogo();
  };

  return (
    <organization-logo-edit-image
      id="image-editor"
      onKeyPress={keyPressed}
      tabIndex={1}
    >
      <GSSidePanelPage
        header={getNavigation()}
        content={getContent()}
        drawer={getDrawer()}
        loading={croppedImgBlob === undefined}
        loadingText={"Loading Image..."}
      ></GSSidePanelPage>
    </organization-logo-edit-image>
  );
};

export default OrganizationLogoEditImage;
